import { render } from "./UpdateTimeline.vue?vue&type=template&id=572edf8e"
import script from "./UpdateTimeline.vue?vue&type=script&lang=ts"
export * from "./UpdateTimeline.vue?vue&type=script&lang=ts"
script.render = render

export default script